<template>
  <b-modal id="selfleswin" size="xl" title="Добавление занятия" @ok="winHide" :ok-only="true">
    <b-tabs content-class="mt-3">
      <b-tab title="Импорт из .xlsx" active>
        <xlsxImportVue :days="days" @export-lessons="exportLessons" />
      </b-tab>
      <!-- lazy: кафедры грузятся с vyatsu.ru только при открытии вкладки -->
      <b-tab title="Расписание кафедры" lazy>
        <deptRaspImport :login="login" :password-a-e-s="passwordAES" @imported="$emit('dept-imported')" />
      </b-tab>
      <b-tab title="Ручное добавление">
        <b-form-datepicker
          v-model="rec.day"
          locale="ru"
          class="mb-2"
          placeholder="Не выбрана дата"
          :label-no-date-selected="'Не выбрана дата'"
          :label-help="'Используйте клавиши курсора для навигации по датам'"
          :label-prev-year="'Предыдущий год'"
          :label-prev-month="'Предыдущий месяц'"
          :label-next-month="'Следующий месяц'"
          :label-next-year="'Следующий год'"
          :label-current-month="'Текущий месяц'"
          :label-today="'Сегодня'"
          :label-close="'Закрыть'"
        ></b-form-datepicker>
        <b-form-select v-model="rec.lesson.time" :options="times" class="mb-2"></b-form-select>
        <b-form-input v-model="rec.lesson.predm" placeholder="Предмет" class="mb-2"></b-form-input>
        <b-form-select v-model="rec.lesson.type" :options="types" class="mb-2"></b-form-select>
        <b-form-input v-model="rec.lesson.kab" placeholder="Кабинет" class="mb-2"></b-form-input>
        <b-form-input v-model="rec.lesson.groups" placeholder="Группа" class="mb-2"></b-form-input>
        <b-button @click="addLessonBtnClick" variant="primary">Добавить занятие в расписание</b-button>
      </b-tab>
    </b-tabs>


  </b-modal>
</template>

<script>
import xlsxImportVue from '../content/xlsxImport.vue'
import deptRaspImport from '../content/deptRaspImport.vue'

export default {
  name: 'selfLesWin',  
  components: {
    xlsxImportVue,
    deptRaspImport,
  },
  props: [
    'days', 'login', 'passwordAES'
  ],
  data() {
    return {
      rec: {
        day: "",
        lesson: {
          time: "8:20-9:50",
          predm: "",
          type: "Лекция",
          kab: "",
          groups: ""
        },
      },
      types: [
        {value: "Лекция", text: "Лекция"},
        {value: "Практика", text: "Практика"},
        {value: "Лабораторная", text: "Лабораторная"},
        {value: "Другое", text: "Другое"}
      ],
      times: [
        {value: "8:20-9:50",   text: "1: 8:20-9:50"},
        {value: "10:00-11:30", text: "2: 10:00-11:30"},
        {value: "11:45-13:15", text: "3: 11:45-13:15"},
        {value: "14:00-15:30", text: "4: 14:00-15:30"},
        {value: "15:45-17:15", text: "5: 15:45-17:15"},
        {value: "17:20-18:50", text: "6: 17:20-18:50"},
        {value: "18:55-20:25", text: "7: 18:55-20:25"}
      ],
    }
  },
  methods: {
    winHide() {
      this.$bvModal.hide('selfleswin')
    },
    addLessonBtnClick() {
      this.$emit("lesson-add", this.rec)
    },
    exportLessons(lessons) {
      this.$emit("lesson-add-multi", lessons)
    }
  }
}
</script>

<style>
svg {
    width: auto !important;
    height: auto !important;
}

/* --- Календарь b-form-datepicker: темизация под токены --- */
.b-calendar,
.b-calendar .b-calendar-grid,
.b-calendar-header {
    background: var(--bg-elevated);
    color: var(--text);
    border-color: var(--border);
}
.b-calendar-grid-caption,
.b-calendar .b-calendar-month {
    color: var(--text);
    font-weight: 700;
}
.b-calendar .b-calendar-weekday {
    color: var(--text-muted);
    font-weight: 600;
    border-color: var(--border);
}
/* Ячейки обычных дней: bootstrap вешает btn-outline-light + text-dark (!important)
   — их тёмный текст невидим на тёмном фоне. Перебиваем обоими селекторами. */
.b-calendar-grid .btn.btn-outline-light,
.b-calendar-grid .btn.btn-outline-dark,
.b-calendar-grid .btn.text-dark {
    color: var(--text) !important;
    background-color: transparent !important;
    border-color: transparent !important;
}
.b-calendar-grid .btn.text-muted {
    color: var(--text-muted) !important;
}
.b-calendar-grid .btn:hover:not(.btn-primary) {
    background-color: var(--item-hover) !important;
    color: var(--text) !important;
}
/* Выбранная дата */
.b-calendar-grid .btn.btn-primary,
.b-calendar-grid .btn.selected,
.b-calendar-grid .btn[aria-selected="true"] {
    background: var(--primary) !important;
    border-color: var(--primary) !important;
    color: var(--on-primary) !important;
    font-weight: 700;
}
/* Сегодня (кольцо) + фокус-навигация */
.b-calendar-grid .btn.btn-outline-primary,
.b-calendar-grid .btn[aria-current="date"] {
    box-shadow: inset 0 0 0 1px var(--primary) !important;
    color: var(--text) !important;
}
/* Серые подложки и подсказка снизу */
.b-calendar .bg-light,
.b-calendar-grid .bg-light,
.b-calendar-grid-help {
    background-color: var(--bg-muted) !important;
}
.b-calendar-grid-help {
    color: var(--text-muted) !important;
    border-color: var(--border) !important;
}
/* Кнопки навигации (год/месяц) */
.b-calendar-nav .btn,
.b-calendar .b-calendar-nav .btn {
    background: transparent !important;
    color: var(--text-muted) !important;
    border-color: var(--border) !important;
}
.b-calendar-nav .btn:hover,
.b-calendar-nav .btn:focus {
    background-color: var(--item-hover) !important;
    color: var(--text) !important;
}
.b-calendar .btn:focus,
.b-calendar-nav .btn:focus {
    box-shadow: 0 0 0 .2rem var(--scrim);
    outline: none;
}

/* Темизированные вкладки (Bootstrap-дефолт плохо ложится на тёмную тему) */
.nav-tabs {
    border-bottom: 1px solid var(--border);
}
.nav-tabs .nav-link {
    background: transparent;
    color: var(--text-muted);
    border: 1px solid transparent;
    border-radius: 0;
    margin-bottom: -1px;
    padding: .6rem 1.15rem;
    font-weight: 500;
    transition: color .15s ease, background-color .15s ease, border-color .15s ease;
}
.nav-tabs .nav-link:hover {
    color: var(--text);
    border-color: var(--border);
}
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: -1px;
    color: var(--text);
}
.nav-tabs .nav-link.active {
    color: var(--primary);
    background-color: var(--bg-elevated);
    border-color: var(--border);
    border-bottom-color: var(--bg-elevated);
    font-weight: 600;
}
.nav-tabs .nav-item {
    margin-bottom: -1px;
}
</style>

